import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import template from '../../../templates/Stones/AssignPricing/card.rt';
import * as actions from '../../../actions';
import {getApiConfig, toFixedPrice} from '../../../utilities';
import { forceCheck } from 'react-lazyload';
import { camelizeKeys } from 'humps';
import _ from 'lodash';
import { imageUnavailable } from '../card.js';
import {AccessRights} from './../../../schemas/accessRightsModel';
import * as pricingPresets from './../../../constants/pricingPresets';

function mapStateToProps(state, props) {
  const {customerInfo} = state.newaccount;
  let hasSlabModeEnabled = false;
  if(customerInfo) {
    hasSlabModeEnabled = customerInfo.toolSettings.kitchen.showSlabMode || customerInfo.toolSettings.kitchen.showSlabModeFromDashboard;
  }
  return {
    presets: state.pricingPreset.presets,
    isSelected: !!state.pricingPreset.selected[props.stone.id],
    AR: AccessRights.get(state),
    hasSlabModeEnabled
  };
}

function mapDispatchToProps(dispatch, { stone }) {
  return {
    onUpdateTransientField: (key, value) => dispatch(actions.updateTransientField(stone, key, _.trim(value)))
  };
}

class adjustPricingCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      price: this.getPrice(props.stone) || 0,
      acceptIncomingChanges: false,
      slabSqftOverridePrice: this.getSlabSqftOverridePrice(props.stone) || 0,
    };
  }
  render = template;

  /**
   * Returns Stone Image URL on S3 or Azure
   * @return {string}
   */
  getStoneImage = () => {
    const {stone} = this.props;
    let imageKey = stone.fabricatorStoneData && stone.fabricatorStoneData.imageKey;
    let imageUrl = imageUnavailable;

    if(stone.thumbUrl)
      imageUrl = stone.thumbUrl;
    else if(stone.imageUrl)
      imageUrl = stone.imageUrl;

    if (imageKey)
      imageUrl = "https://s3.amazonaws.com/stone_images/sss-thumbnail-" + imageKey;

    return imageUrl;
  }


  getPrice(stone) {
    let price = 0;
    if (stone.fabricatorStoneData && stone.fabricatorStoneData.price > 0) {
      price = stone.fabricatorStoneData.price;
    }
    let profile = this.getPricingProfile();
    let hasProfileAndShowAnyway = (profile && profile.data && profile.data[0] && profile.data[0].type == pricingPresets.PRICING_PRESET_SLAB_SEG);
    if(hasProfileAndShowAnyway) {
      if(price == 0 || !stone.fabricatorStoneData.profilePriceOverride) {
        price = profile.data[0].value;
      }
    }

    return price ? toFixedPrice(+price) : price
  }

  getSlabSqftOverridePrice(stone) {
    let price = 0;
    if (stone.fabricatorStoneData && stone.fabricatorStoneData.slabSqftOverridePrice > 0) {
      price = stone.fabricatorStoneData.slabSqftOverridePrice;
    }
    let profile = this.getPricingProfile();
    let hasProfileAndShowAnyway = (profile && profile.data && profile.data[0] && profile.data[0].type == pricingPresets.PRICING_PRESET_SLAB_SEG);
    if(hasProfileAndShowAnyway) {
      if(price == 0 || !stone.fabricatorStoneData.slabSqftOverridePrice) {
        price = profile.data[0].slabSqftValue;
      }
    }

    return price ? toFixedPrice(+price) : price
  }


  getPricingProfile = () => {
    for(var i = 0; i < this.props.presets.length; i++) {
      var preset = this.props.presets[i];
      if(preset.id == this.getPricingId()) {
        return preset;
      }
    }
  }

  shouldShowPriceAnyway = () => {
    let profile = this.getPricingProfile();
    return (profile && profile.data && profile.data[0] && profile.data[0].type == pricingPresets.PRICING_PRESET_SLAB_SEG);
  }

  
  isAssignedPricingSlab() {
    let pricingProfile = this.getPricingProfile();
    if(!!pricingProfile) {
      return pricingProfile.data[0].type == pricingPresets.PRICING_PRESET_SLAB_SEG;
    }
    return false;
  }

  /**
   * Returns Preset Id
   * @return {int}
   */
  getPricingId = () => {
    return this.props.stone.fabricatorStoneData && this.props.stone.fabricatorStoneData.pricingPresetId;
  }

  /**
   * returns Assigned Pricing Profile Icon url
   * @return {string}
   */
  getPricingProfileIcon = () => {
    for(var i = 0; i < this.props.presets.length; i++) {
      var preset = this.props.presets[i];
      if(preset.id == this.getPricingId()) {
        return preset.icon;
      }
    }
  }

  /**
   * Returns if stone is assigned a Pricing Profile
   * @return {bool}
   */
  isAssignedPricingProfile = () => {
    //https://stackoverflow.com/a/784946
    return !!this.getPricingProfile();
  }

  /**
   * Calculates and returns the correct stone display name
   * @return {string}
   */
  getStoneName = () => {
    const {stone} = this.props;
    let customStoneName = stone.fabricatorStoneData && stone.fabricatorStoneData.customStoneName;
    let name = customStoneName || stone.name;
    if (name && name.replace(' ', '').length === 0) {
      name = stone.name;
    }
    return name;
  }

  updatePriceTransientfield(value) {
    let newVal = value.replace(/[^0-9\.\-]/g, '');
    this.setState({price: newVal}, () => {
      this.props.onUpdateTransientField('price', newVal);
    });
  }

  updateSlabSqftOverridePriceTransientfield(value) {
    let newVal = value.replace(/[^0-9\.\-]/g, '');
    this.setState({slabSqftOverridePrice: newVal}, () => {
      this.props.onUpdateTransientField('slabSqftOverridePrice', newVal);
    });
  }

  onChange(key, value) {
    if(this._changeTimeout) {
      window.clearTimeout(this._changeTimeout);
    }
    this.setState({[key]: value}, () => {
      this._changeTimeout = window.setTimeout(() => {
        this.props.onUpdateTransientField(key, value);
      }, 250);
    });
  }

  /**
   * Toggles selected state on card
   */
  toggleSelection = () => {
    this.props.onSelectionToggled(this.props.stone);
  }


  setAcceptIncomingChanges = () => {
    this.setState({acceptIncomingChanges: true});
  }

  componentDidMount() {
    //document.getElementsByTagName('section')[0].addEventListener("scroll", forceCheck);
    document.addEventListener("transientUpdatesCleared", this.setAcceptIncomingChanges);
  }

  componentWillUnmount() {
    document.removeEventListener("transientUpdatesCleared", this.setAcceptIncomingChanges);
    document.getElementsByTagName('section')[0].removeEventListener("scroll", forceCheck);
  }

  componentDidUpdate(props) {
    let price = this.getPrice(props.stone) || 0;
    let slabSqftOverridePrice = this.getSlabSqftOverridePrice(props.stone) || 0;
    if(this.state.acceptIncomingChanges != false || (this.state.price == 0 && price > 0) || (this.state.slabSqftOverridePrice == 0 && slabSqftOverridePrice > 0)) {
      this.setState({
        price,
        acceptIncomingChanges: false,
        slabSqftOverridePrice
      });
    }
  }
}

adjustPricingCard.propTypes = {
  onSelectionToggled: PropTypes.func.isRequired,
  stone: PropTypes.oneOfType([PropTypes.func, PropTypes.object]).isRequired
};

const AdjustPricingCard = connect(mapStateToProps, mapDispatchToProps)(adjustPricingCard);

export { AdjustPricingCard };
